<template>
  <Account title="Branch activity">
    <AccountHistoryTable depth="branch" />
  </Account>
</template>

<script>
export default {
  name: 'AccountActivityBranch',
  components: {
    Account: () => import('./Account'),
    AccountHistoryTable: () =>
      import('../components/history/AccountHistoryTable')
  }
}
</script>
